import { type MessageKey, t } from '../../i18n';

// Datos de /api/proveedores (guía 7.7).

export interface SupplierListItem {
  id: string;
  tradeName: string;
  legalName: string;
  taxId: string;
  country: string | null;
  email: string | null;
  phone: string | null;
  active: boolean;
  updatedAt: string;
}

export interface SupplierValues {
  tradeName: string;
  legalName: string;
  taxId: string;
  country: string | null;
  address: string | null;
  contactName: string | null;
  email: string | null;
  phone: string | null;
  bankName: string | null;
  bankAccount: string | null;
  bankAccountType: 'ahorros' | 'corriente' | null;
  bankAccountHolder: string | null;
  notes: string | null;
}

export interface SupplierDetail extends SupplierValues {
  id: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  createdByName: string | null;
  updatedByName: string | null;
  can: { manage: boolean };
}

export interface HistoryEntry {
  id: string;
  action: string;
  actor: string | null;
  at: string;
  changes: Array<{ field: string; before: unknown; after: unknown; bank: boolean }>;
}

export const SUPPLIER_FIELDS: ReadonlyArray<keyof SupplierValues> = [
  'tradeName',
  'legalName',
  'taxId',
  'country',
  'address',
  'contactName',
  'email',
  'phone',
  'bankName',
  'bankAccount',
  'bankAccountType',
  'bankAccountHolder',
  'notes',
];

/** Nombre de un campo en el historial (incluye "active", que no se edita en el formulario). */
export const fieldName = (field: string) => t(`pv.campo_${field}` as MessageKey);

/** Valor de un campo tal como se muestra en el historial. */
export function fieldValue(field: string, value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (field === 'active') return value ? t('pv.activo') : t('pv.inactivo');
  if (field === 'bankAccountType') return t(`pv.cuenta_${String(value)}` as MessageKey);
  return String(value);
}
